<template>
     <div style="width:1300px;margin:0 auto;">
              <!-- <div class="row scroll_content">
                   <div>
                      <img class="scrollBox" src="../../static/images/laba.png" alt="">
                   </div>
                  <div>
                      <Scroller :lists="lists" class="scrollContainer left" />
                  </div>
              </div> -->
            <div class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:70px;">
                <p class="text-center mb-2">
                     <span style="font-size:20px;">
                       审阅日志
                     </span>
                      <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                      </span>
                </p>
                <div class="content_log">
                                     <img class="log_img" src="../../static/images/rizi1.jpg" alt="">
                                        <div>
                                             <div>
                                                  <section>
                                                       <span style="font-size:25px;">
                                                            标题:
                                                       </span>
                                                       <span class="log_title">
                                                            {{title}}
                                                       </span>
                                                  </section>
                                             </div>
                                             <div>
                                                  <p style="font-size:15px;">
                                                       <span>
                                                            作者：
                                                            <span>
                                                                 {{author}}
                                                            </span>
                                                       </span>
                                                  </p>
                                             </div>

                                       </div>
                         
                                             
                                   
                                            
                </div>
                <!-- <div style="width:300px;height:150px;float:right;">
                         <img style="width:100px;height:100px;" src="../../static/images/rizi2.jpg" alt="">
                </div> -->
                <div>
                            <div>
                                       <p class="mt-2 mb-2">
                                             <span style="font-size:20px;">
                                                内容主体:
                                             </span>
                                       </p>
                                                  <div>
                                                       <section v-html="content" class="text-center mt-2">
                                                                 {{content}}
                                                       </section>
                                                       <p>
                                                            <span>
                                                                 图片:
                                                            </span>
                                                       </p>
                                                        <div>
                                                                 <img style="width:100px;height:100px;" :src="'http://fw.hyey.cn'+image1" alt="">
                                                                 <img style="width:100px;height:100px;" :src="'http://fw.hyey.cn'+image2" alt="">
                                                                 <img style="width:100px;height:100px;" :src="'http://fw.hyey.cn'+image3" alt="">
                                                                 <img style="width:100px;height:100px;" :src="'http://fw.hyey.cn'+image4" alt="">
                                                                 <img style="width:100px;height:100px;" :src="'http://fw.hyey.cn'+image5" alt="">
                                                        </div>
                                                  </div>
                               </div>
                </div>
                <p class="text-center mt-5">
                      <!-- <button class="btn btn-primary" @click="modificationBlog()">
                           审阅
                      </button> -->
                      <button class="btn btn-primary" @click="getGongShi()">
                           公示
                      </button>
                </p>
            </div>
     </div>
</template>
<script>
import Scroller from '../pages/manager/Scroller.vue';
export default {
     data(){
          return{
              lxs:'',
              state:'',
              pageIndex:'',
              id:'',
              title:"",
              content:'',
              author:'',
              lists:['公示内容'],
              image1:'',
              image2:'',
              image3:'',
              image4:'',
              image5:'',
          }
      },
   filters:{
          changeTitle:function(title){
              if(title==null){
                       return title
                  }
                  else{
                       return title.substring(22);
                  }
        }
   },
    components:{
     Scroller,
  },
      methods:{
       //公示
       getGongShi:async function(){
              const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkUpBlog',
          obj: JSON.stringify({
                lxs:'6',
                state:'1',
                id:this.id,
          })
        })
     //    console.log(res)
        if (res.isok) {
             if(res.data.isok){
                  this.$message.success(res.data.msg)
                  const obj = res.data;
             }
             else{
                  alert(res.data.msg)
             }
        }
        else{
             alert(res.message)
        }
       },

      //审阅日志
       modificationBlog:async function(){
          const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkUpBlog',
          obj: JSON.stringify({
                username:'kzy001',
                lxs:'2',
                state:'1',
               //  contents:this.content,
                id:this.id,
               //  title:this.title,
               //  reply:'',
          })
        })
        console.log(res)
        if (res.isok) {
             if(res.data.isok){
                  this.$message.success(res.data.msg)
                  const obj = res.data;
             }
             else{
                  alert(res.data.msg)
             }
        }
        else{
             alert(res.message)
        }
       },
       //查看日志
       lookBlog:async function(){
              // this.getNowTime()
            const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkLookBlog',
          obj: JSON.stringify({
               //  username:'kzy001',
                lxs:'1',
                state:'0',
                id:this.id,
          })
        })
        console.log(res)
        if (res.isok) {
             if(res.data.isok){
                  const obj = res.data;
                  this.title=obj.rows[0].title;
                  // console.log(this.title)
                  this.content=obj.rows[0].contents;
                  this.author = obj.rows[0].truename;
                  this.image1 = obj.rows[0].image1;
                  this.image2 = obj.rows[0].image2;
                  this.image3 = obj.rows[0].image3;
                  this.image4 = obj.rows[0].image4;
                  this.image5 = obj.rows[0].image5;
             }
        }
       },
    getID(){
         this.id=this.$route.query.id;
      }

      },
      created(){
          this.getID();
          this.lookBlog();
          // this.getGongShi();
      }

}
</script>
<style lang="less" scoped>
.jz_middle{
   vertical-align:middle;
 }
 .span_close:hover{
       color:#3190e8;
 }
.content_log{
     .log_img{
          width:100px;
          height:100px;
     }
}
.log_title{
     font-size:25px;
}
.scrollContainer {
// margin-top:30px;
color: #ffffff;
// display: flex;
// align-items: center;
font-size: 16px;
// margin-left: 180px;
width:100%;
line-height: 30px;
overflow: hidden;
 }
.scrollBox{
  margin-left:100px;
  width:30px;
  height:30px;
}
.scroll_content{
   align-items: center;
}
</style>




// WEBPACK FOOTER //
// src/pages/getLog.vue